// extracted by mini-css-extract-plugin
export default {"container":"_Z-z","list":"a0-z"};